import React from 'react';

export interface EstrellaAmarillaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const EstrellaAmarillaIcon: React.FC<EstrellaAmarillaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 5 3.09 6.26L25 12.27l-5 4.87 1.18 6.88L15 20.77l-6.18 3.25L10 17.14l-5-4.87 6.91-1.01z"/></g><defs><filter id="a" width="32" height="32" x="-1" y="-1" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_49_89597"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_49_89597" mode="multiply" result="effect2_dropShadow_49_89597"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_49_89597" result="shape"/></filter></defs>
    </svg>
  );
};

export default EstrellaAmarillaIcon;
